import angular from 'angular';
import 'angular-toastr';
import 'angular-translate';
import filtersModule from '../filters/filters'

export default angular.module('app.services.notify', [
  filtersModule.name,
  'pascalprecht.translate',
  'toastr'
])
  .config(['toastrConfig', function (toastrConfig) {
    angular.extend(toastrConfig, {
      closeButton: true,
      closeHtml: `<button gg-icon="icon-close"></button>`,
      tapToDismiss: false,
      preventOpenDuplicates: true,
      timeOut: 0,
      allowHtml: true
    });
  }])
  .service('notify', function (toastr, $filter) {
    let translate = $filter('translate');

    let notify = ((notifyType, notifyKey, notifyValues) => {
      toastr[notifyType](
        translate(`$notify.${notifyKey}.message`, notifyValues),
        translate(`$notify.${notifyKey}.title`),
        {
          timeOut: 5000
        }
      );
    });

    let resourceActionNotify = ((actionName, resourceType, resourceName) => {
      resourceType = translate(resourceType);
      notify('success', 'resourceAction', {resourceType, resourceName, actionName})
    });

    return angular.extend({}, toastr, {
      apiError: (response) => {
        let data = _.get(response, 'data');
        if (_.isString(data)) {
          try {
            data = JSON.parse(data);
          } catch (e) {
            // leave as string
          }
        }
        let error = _.get(data, 'detail') || _.get(data, 'error') || _.get(data, 'message') || (_.isString(data) ? data : null);

        if (error) {
          toastr.error(error, translate(`$notify.apiError.title`));
        } else {
          toastr.error(
            `${response.status}: ${response.statusText}`,
            translate(`$notify.apiError.title`)
          );
        }
      },
      // TODO: refactor to notify.resourceAction('created', 'game', 'Game 1');
      created: ((resourceType, resourceName) => resourceActionNotify('created', resourceType, resourceName)),
      updated: ((resourceType, resourceName) => resourceActionNotify('updated', resourceType, resourceName)),
      removed: ((resourceType, resourceName) => resourceActionNotify('removed', resourceType, resourceName)),
      duplicated: ((resourceType, resourceName) => resourceActionNotify('duplicated', resourceType, resourceName)),
      success: ((notifyKey, notifyValues) => notify('success', notifyKey, notifyValues)),
      error: ((notifyKey, notifyValues) => notify('error', notifyKey, notifyValues)),
      warning: ((notifyKey, notifyValues) => notify('warning', notifyKey, notifyValues))
    });
  })



/** WEBPACK FOOTER **
 ** ./src/services/notify.js
 **/